import { Injectable } from '@angular/core';
import { Event } from '../classes/classes';

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  constructor() { }

  // add variables for gradient
  private rs_gradient = {
    top: '#044084',
    bottom: '#022042'
  }

  private pi_gradient = {
    top: '#3C7ABF',
    bottom: '#1E3D60'
  }

  private dt_gradient = {
    top: '#676767',
    bottom: '#1c1c1c'
  }

  public get_events() {
    const events: Event[] = [
      new Event(
        false,
        'Understanding Easements Live Broadcast',
        '<br/>Stay Connected with CLS PI and join our complimentary live broadcast training session on Understanding Easements. For the full agenda and to register your place, please<br/> <a target="_blank" href="https://attendee.gotowebinar.com/register/1004679158970042380">click here<a/>.',
        [],
        'CLS Property Insight',
        '3',
        'Sep',
        this.rs_gradient.top,
        this.rs_gradient.bottom,
        '',
        'marketing@clsl.co.uk?subject=Understanding Easements Webinar',
        new Date("2020-09-03")
      ),
      new Event(
        false,
        'The Impact of Japanese Knotweed on Conveyancing Live Broadcast',
        'An insightful training session on understanding Japanese Knotweed and guidance on the Law Society TA6 Property Information Form. Discover the agenda and register your place by <a target="_blank" href="https://attendee.gotowebinar.com/register/1888655721376461324">clicking here<a/>.',
        [],
        'CLS Property Insight',
        '17',
        'Sep',
        this.rs_gradient.top,
        this.rs_gradient.bottom,
        '',
        'marketing@clsl.co.uk?subject=Understanding Easements Webinar',
        new Date("2020-09-17")
      ),
      new Event(
        false,
        'Understanding the Insurance Distribution Directive (IDD) Live Broadcast',
        'An informative training session on the new requirements introduced with IDD and what solicitors need to do to comply. <a target="_blank" href="https://attendee.gotowebinar.com/register/1690379690028050956">Click here<a/> to register your place.',
        [],
        'CLS Property Insight',
        '1',
        'Oct',
        this.rs_gradient.top,
        this.rs_gradient.bottom,
        '',
        'marketing@clsl.co.uk?subject=Understanding Easements Webinar',
        new Date("2020-10-01")
      ),
      new Event(
        false,
        'Understanding Defective Lease Live Broadcast',
        'Find out more about online and bespoke defective leasehold policies as well as claims, case studies and likely scenarios within our live training session. <a target="_blank" href="https://attendee.gotowebinar.com/register/5135411303617817100">Click here<a/> to register.',
        [],
        'CLS Property Insight',
        '15',
        'Oct',
        this.rs_gradient.top,
        this.rs_gradient.bottom,
        '',
        'marketing@clsl.co.uk?subject=Understanding Easements Webinar',
        new Date("2020-10-15")
      ),
      new Event(
        false,
        'Restrictive Covenant in Property Transactions Live Broadcast',
        'Our National Key Account Manager will provide further insight on Restrictive Covenants including case studies and considerations for conveyancers within this live training session. <a target="_blank" href="https://attendee.gotowebinar.com/register/1021767768689371660">Click here<a/> to register.',
        [],
        'CLS Property Insight',
        '29',
        'Oct',
        this.rs_gradient.top,
        this.rs_gradient.bottom,
        '',
        'marketing@clsl.co.uk?subject=Understanding Easements Webinar',
        new Date("2020-10-29")
      ),
    ];
    const todaysDate = new Date();
    const eventsnew = events.filter(event => {
      return event.EventDate > todaysDate;
    });

    return eventsnew;
  }

}
